import { cloneElement, ReactElement } from 'react'

import { useRouter } from './Router'
import { StringOrStringArray } from './types'

export function Route({
  name,
  lang,
  children,
}: {
  name: string
  lang: string
  children:
    | ((props: { params?: Record<string, StringOrStringArray> }) => ReactElement)
    | ReactElement
}) {
  const { matchedRoutes } = useRouter()
  const route = matchedRoutes.find((x) => x.name === name && x.lang === lang)
  if (!route) {
    return null
  }
  const props = { params: route.params }
  if (typeof children === 'function') {
    return children(props)
  }
  return cloneElement(children, props)
}
